import { DefaultSliceState, RootState } from 'src/app/types';

const getState = (state: RootState): DefaultSliceState => state.createFromTemplate;

export const getIsLoading = (state: RootState): boolean => getState(state).isLoading;

export const getError = (state: RootState): string => getState(state).error;
